function ninjaGameEaster(canvasJQ,game_conf,conf){
    ninjaGame.call(this,canvasJQ,game_conf,conf);


    var i,imgObj={},eggs=["waves","pink","dots","stripes","teal"],j=0;
    var thisMaster = this;

    this.eggs = eggs;
    this.confMaster = conf;

    for(i in eggs) {
      var egg = eggs[i];
      imgObj["egg"+j] = _IMG_SERV+"/gfx/place/gameninja/cutimages/eggs/"+egg+"/egg.png";
      // for(var k=0;k<4;k++){
      //     imgObj["egg"+j+"_"+k]=_IMG_SERV+"/gfx/place/gameninja/cutimages/eggs/"+egg+"/"+k+".png";
      // }
      j++;
    }
    this.isBossNextStageCfg=false;
    this.game_obj = new cutGame(canvasJQ,{
        imagesPreloader:$.extend(imgObj,{
            eggDie:_IMG_SERV+"/gfx/place/gameninja/cutimages/egg_kill.png",
            boss:_IMG_SERV+"/gfx/place/gameninja/cutimages/boss/boss.png"
        }),
        spinePreloader:{
            eggs: _IMG_SERV+"/gfx/place/gameninja/cutimages/eggs/spine/skeleton.json",
            eggBoss: _IMG_SERV+"/gfx/place/gameninja/cutimages/boss/spine/skeleton.json",
            chicken: _IMG_SERV+"/gfx/place/gameninja/cutimages/chicken/spine/skeleton.json",
        },
        onLoad:function(){
            $.triggerPlacePreloader(1);
        }
    });

    var gameObj=this.game_obj;

    function eggBoss(bonus2){
      this.thc = thisMaster;
      this.gameObj=this.thc.game_obj;
      //var game_state=this.state;
      this.gameConf=this.thc.game_conf;
      this.confMaster = this.thc.confMaster;
      this.needCuts=5;
    }

    eggBoss.prototype = $.extend(eggBoss.prototype,{
      addBoss:function() {
        var th = this;
        _moduleTimeHandler.setOne(_moduleTimeHandler.getNewIndex(),function() {
          th.thc.isBossNextStageCfg.isBoss=0;
          th.thc.nextStage(th.thc.isBossNextStageCfg);

          th.gameObj.addThrow("boss",$.extend(copyObj(th.gameConf.hard_row),{
              // h_max:780,
              // w_margin:50,
              anim_type:"img",
              img:"boss",
              map_name:"easter_boss",
              //g:0.01,
              //step_part:mt_rand(50,60)/100,
              scale_arr:[100,100],
              boss_die_count: th.needCuts,
              onCut:function(obj){
                _mySound.playSound("game_cut_good_word");
                th.updateBossHits(th.needCuts-obj.bossHits);

                if(obj.bossHits>=th.needCuts){
                  _mySound.playSound("glass_crush");
                  th.thc.stage.res="win";
                  th.confMaster.onWin(obj);
                  th.updateBossHits(-1);
                  var pos=obj.cut_data.pos;
                  var scale=50;//obj.cut_data.scale
                  var qobj=this.addViewObj(myPixiObj.drawCustom,[{
                     spine_conf:{
                         spineResource:gameObj.takeSpineResources(),
                         onAnimComplete:function(){
                             qobj.step_max=1;
                         }
                     },
                     anim_type:"spine",
                     img:"eggBoss",
                     scale_arr:[scale,scale],
                     rotation_arr:[obj.cut_data.angle],
                     step_max:0,
                     dir:obj.cut_data.dir,
                     v:3,
                     pos_start:pos,pos_end:pos
                 }]);
                }
              },
              onEnd:function(obj){
                th.confMaster.onLose({reason_id:3});
              }
          }));
        },1000);
      },
      updateBossHits:function(val){
        var bossBox=$(".place.gameninja").find("#bossInfoJS");
        if(val===-1){
          bossBox.hide();
        }
        bossBox.find("#bossInfoValJS").html(val);
      },
      showInfo:function(){
        var bossBox=$(".place.gameninja").find("#bossInfoJS");
        var th=this,queueIndex = _moduleTimeHandler.getNewIndex(),animIndex = _moduleTimeHandler.getNewIndex();

        //this.updateBossHits(this.needCuts-obj.bossHits);
        bossBox.animate({opacity:1},2200);
        _moduleTimeHandler.queueAdd(queueIndex,function(){
            bossBox.find(".descJS").animate({opacity:0},400);
            _moduleTimeHandler.setOne(animIndex,function(){
                bossBox.find(".xJS").show().animate({opacity:1},400)
                _moduleTimeHandler.queueTrigger(queueIndex);
            },400);
        });
        _moduleTimeHandler.queueAdd(queueIndex,function(){
            bossBox.animate({"margin-top":"-300px"},900,th.addBoss());
        });
        _moduleTimeHandler.setOne(animIndex,function(){
            _moduleTimeHandler.queueTrigger(queueIndex);
        },4000);
      },
    })
    this.eggBoss = new eggBoss();
};


ninjaGameEaster.prototype = Object.create(ninjaGame.prototype);
ninjaGameEaster.prototype=$.extend(ninjaGameEaster.prototype,{
    test:function(){
      var conf = {
        egg_min: 2,
        egg_max: 2,
        // chick_min:5,
        // chick_max:5
      };
      this.gameHandler();

      this.nextStage(conf);
      //this.startBoss();
    },
    startView:function(){

    },
    nextStage:function(conf){
      if(typeof conf.isBoss !== "undefined") {
        if(conf.isBoss>0){
          this.isBossNextStageCfg = conf;
          return 0;
        } else {
          this.isBossNextStageCfg.isBoss=1;
        }

      }


        var egg=mt_rand(conf.egg_min,conf.egg_max);
        var chick=mt_rand(conf.chick_min,conf.chick_max);

        var gameObj=this.game_obj;
        var gameConf=this.game_conf;
        var i,eggs=this.eggs;
        if(egg>0){
          _moduleEvents.trigger("addEgg");
        }
        function addEgg(){
            var val=mt_rand(0,eggs.length-1);
            var scale=mt_rand(90,100);

            gameObj.addThrow("egg",$.extend(copyObj(gameConf.hard_row),{
                sprite_conf:{
                    clips:1,
                    frame_duration:200,
                    floop:false
                },
                anim_type:"sprite",
                img:"egg"+val,
                map_name:"halloween_egg1",
                rotation_step_arr:[3,12],
                scale_arr:[scale,scale],
                onCut:function(obj){
                    _mySound.playSound("game_cut_good_word");
                    var angle_die=mt_rand(0,359);
                    var eggName = eggs[val];

                     var pos=obj.cut_data.pos;
                     //var scale=100;//obj.cut_data.scale
                    var qobj=this.addViewObj(myPixiObj.drawCustom,[{
                        spine_conf:{
                            spineResource:gameObj.takeSpineResources(),
                            onAnimComplete:function(){
                                qobj.step_max=1;
                            }
                        },
                        anim_type:"spine",
                        img:"eggs",
                        scale_arr:[scale,scale],
                        rotation_arr:[obj.cut_data.angle,obj.cut_data.angle],
                        step_max:0,
                        dir:obj.cut_data.dir,
                        v:3,
                        pos_start:pos,pos_end:pos
                    }]);

                    var parts=["down","up","left","right"];
                    for(var i in parts) {
                      var part = parts[i];
                      qobj.myObj.showAttachment(part,"egg_"+part+"_"+eggName);
                    }
                },
                onEnd:function(obj){
                    _mySound.playSound("egg_crash");
                }
            }));
        }

        for(i=0;i<egg;i++){
            addEgg();
        }

        function addChick(){
            _mySound.playSound("chick");
            var qobj = gameObj.addThrow("chick",$.extend(copyObj(gameConf.hard_row),{
                h_max:780,
                w_margin:50,
                spine_conf:{
                    spineResource:gameObj.takeSpineResources(),
                    anim_name:"animation",
                    anim_loop:true
                },
                anim_type:"spine",
                img:"chicken",
                map_name:"easter_chicken",
                scale_arr:[50,50],
                step_max:0,
                step_part:mt_rand(50,60)/100,
                onCut:function(obj){
                  cutChicken(this,obj)
                },
                onEnd:function(obj){
                  _mySound.playSound("chick");
                  var dir = 1;
                  var pos_start=obj.cut_data.pos,moveChicken = mt_rand(0,100);
                  if(moveChicken<60){
                    moveChicken = mt_rand(500,1200);
                    dir=-1;
                  } else {
                    moveChicken = -mt_rand(500,1200);
                  }
                  var pos_end=[pos_start[0]+moveChicken,1000];
                  var chick=gameObj.addCollisionCustom("chick",{
                      spine_conf:{
                          spineResource:gameObj.takeSpineResources(),
                          anim_name:"animation2",
                          anim_loop:true
                      },
                      anim_type:"spine",
                      img:"chicken",
                      map_name:"easter_chicken",
                      scale_arr:[50,50],
                      pos_start:pos_start,
                      pos_end:pos_end,
                      v:3,
                      dir:dir,
                      onCut:function (obj) {
                        cutChicken(this,obj)
                      },
                      onEnd:function (obj) {

                      }
                  });
                }
            }));

            function cutChicken (thObj,obj){
              _mySound.playSound("chick_die");
              var pos=obj.cut_data.pos,scale=obj.cut_data.scale;
              var qobj=thObj.addViewObj(myPixiObj.drawCustom,[{
                  spine_conf:{
                      spineResource:gameObj.takeSpineResources(),
                      onAnimComplete:function(){
                          qobj.step_max=1;
                      },
                      anim_name:"animation3",
                  },
                  anim_type:"spine",
                  img:"chicken",
                  scale_arr:[scale,scale],
                  rotation_arr:[obj.cut_data.angle],
                  step_max:0,
                  dir:obj.cut_data.dir,
                  pos_start:pos,pos_end:pos
              }]);
            }
        }
        for(i=0;i<chick;i++){
            addChick();
        }
    },

    startBoss:function(){

        var uiJS=$(".place.gameninja");
        uiJS.find("#eggBox").hide();
        //uiJS.find("#witchBox").show();
        //this.updateWitch();

        this.eggBoss.showInfo();
    },
    updateWitch:function(){
        var uiJS=$(".place.hallninja #hallGameUI #witchBox");
        var wrapHead=uiJS.find('#headWrapJS'),html="";
        var i=0,i_max=this.state.boss.val_need;
        for(i=0;i<i_max;i++){
            if(i_max-i>this.state.boss.val){
                html+="<div class='head'><div class='in'></div></div>";
            }
            else{
                html+="<div class='head cut'><div class='in'></div></div>";
            }
        }
        wrapHead.html(html);
    },
    gameHandler:function(){
        var thc=this;
        var gameObj=this.game_obj;

        var uiJS=$(".place.gameninja");


        function updateScore(){
            var eggUI=uiJS.find("#eggBox");
            eggUI.find("#showPointsJS").html(thc.state.val);
            var percent=thc.state.val/thc.state.val_need*100;
            percent=Math.min(100,percent);
            eggUI.find(".beltWrap>.fill").height(percent+"%");
        }
        function getLive(howmany,reason_id){
            thc.state.lives-=howmany;
            if(thc.state.lives<=0 && thc.stage.res==""){
                gameObj.stopCut();
                thc.stage.res="lose";
                thc.conf.onLose({val:thc.state.val,reason_id:reason_id});
            }
            thc.state.lives=Math.max(thc.state.lives,0);


            var wrapHead=uiJS.find('#heartWrapJS'),html="";
            var i=0,i_max=thc.state.lives_max;
            for(i=1;i<i_max+1;i++){
                if(intval(thc.state.lives)>=i){
                    html+="<div class='cell' data-active='1'></div>";
                }
                else{
                    html+="<div class='cell'></div>";
                }
            }
            wrapHead.html(html);

        }
        updateScore();
        getLive(0);

        _moduleEvents.on("cutGameEvent",function(obj){
            var log_arr=gameObj.getLogs();
            var i,bum,change_live=0,change_score=0;
            for(i in log_arr){
                bum=log_arr[i];
                var cut_data=bum.cut_data;
                if(bum.type=="cut"){
                    if(cut_data.type=="egg"){
                        //score
                        thc.state.val+=1;
                        change_score++;
                    }
                    if(cut_data.type=="chick"){
                        getLive(1,1);
                    }
                }
                if(bum.type=="end"){
                    if(cut_data.type=="egg"){
                        //lose
                        getLive(1,2);
                    }
                }
            }

            if(change_score){
                updateScore();
            }
        });




    }
});
